var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"sidebar"},[_c('div',{staticClass:"menu"},[_c('GameMenu')],1),_c('div',{staticClass:"wallet"},[_c('Wallet')],1),_c('div',{staticClass:"inventory"},[_c('Inventory')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }